import { useContext, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router'

import { useNav } from 'app/Nav'
import { pathTo } from 'libreon/routes'
import GlobalContext from 'reducer/global'

import SignForm from './Form'

export function AuthSignOn() {
  useNav('auth')

  const navigate = useNavigate()
  const [{ user }] = useContext(GlobalContext)
  const { up } = useParams()

  useEffect(() => {
    if (user.isAuthN) {
      if (user.age < 1) {
        navigate(pathTo('user_profile', user))
      } else if (window.location.pathname.includes('signon')) {
        navigate('/')
        // } else if (user.isIdentified) {
        //   navigate(pathTo('...'))
      }
    }
  }, [navigate, user])

  return <SignForm signup={!!up} />
}
